import React, {useMemo, useState} from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Flex,
  ModalCloseButton,
} from '@chakra-ui/react';
import {AnalystWizard} from './AnalystWizard';
import {useResetAgentBuilder} from '../hooks/useResetAgentBuilder';
import {AgentBuilderContent} from '../AgentBuilderModal';
import {ObjectId} from 'bson';
import {SegmentationWizard} from './SegmentationWizard';

export type AgentWizard = 'analyst' | 'segmentation';

export const AgentWizardModal = ({
  isOpen,
  onClose,
  wizardType,
}: {
  isOpen: boolean;
  onClose: () => void;
  wizardType: AgentWizard;
}) => {
  const resetAgentBuilder = useResetAgentBuilder();

  return (
    <Modal
      isCentered={true}
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={resetAgentBuilder}
      size="full"
    >
      <ModalOverlay />
      <ModalContent>
        <AgentWizardContent wizardType={wizardType} />
      </ModalContent>
    </Modal>
  );
};

const AgentWizardContent = ({wizardType}: {wizardType: AgentWizard}) => {
  const [agentId, setAgentId] = useState<ObjectId | undefined>();

  const wizards = useMemo(
    () =>
      ({
        analyst: <AnalystWizard onContinue={setAgentId} />,
        segmentation: <SegmentationWizard onContinue={setAgentId} />,
      }) satisfies Record<AgentWizard, React.ReactNode>,
    []
  );

  if (agentId) {
    return <AgentBuilderContent agentId={agentId} initialStep="setName" />;
  }

  return (
    <>
      <ModalBody as={Flex} flexDirection="column" p="0">
        {wizards[wizardType]}
      </ModalBody>
      <ModalCloseButton />
    </>
  );
};
